import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';

function SaveButton({ buttonTitle, type, loading, loadingText, disabled }) {
  const isDisabled = !!loading || !!disabled;
  const label = loading ? (loadingText || 'Loading...') : buttonTitle;

  return (
    <>
      <Button
        type={type}
        className="rounded-1"
        style={{ backgroundColor: '#328277' }}
        disabled={isDisabled}
      >
        {loading && (
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            className="me-2"
          />
        )}
        {label}
      </Button>{' '}
    </>
  );
}

export default SaveButton;